import { datadogLogs } from '@datadog/browser-logs';
import { config } from '../config';

// CURRENT LOGGING BEHAVIOUR
// LOCAL env → console logging
// DEV and PROD env → datadog logging

const envLocation = `[${config.serviceName}]`;

const logMethod = (level: 'debug' | 'info' | 'warn' | 'error', args: unknown[]) => {
    if (import.meta.env.DEV) {
        (console[level] as (...args: unknown[]) => void)(envLocation, ...args);
    } else {
        const message = args.length > 0 ? `${envLocation} ${args.join(' ')}` : envLocation;
        datadogLogs.logger[level](message);
    }
};

/* eslint-disable no-console */
export const trace = {
    debug: (...args: unknown[]) => logMethod('debug', args),
    info: (...args: unknown[]) => logMethod('info', args),
    warn: (...args: unknown[]) => logMethod('warn', args),
    error: (...args: unknown[]) => logMethod('error', args),
};
